import { Mail, MapPin, Phone } from 'lucide-react'
import React from 'react'

const Contact = () => {
    return (
        <section id="contact" className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-3xl lg:text-4xl font-bold text-[#002047] mb-4">
                        Get in Touch
                    </h2>
                    <p className="text-xl text-gray-600">
                        Have questions? We're here to help you succeed
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-12">
                    <div className="space-y-8">
                        <div className="flex items-start space-x-4">
                            <div className="bg-[#002047] p-3 rounded-lg">
                                <Phone className="h-6 w-6 text-white" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-[#002047] mb-2">Phone</h3>
                                <p className="text-gray-600">+91 9352515824</p>
                                <p className="text-sm text-gray-500">Mon-Sat 10AM-7PM IST</p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4">
                            <div className="bg-[#002047] p-3 rounded-lg">
                                <Mail className="h-6 w-6 text-white" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-[#002047] mb-2">Email</h3>
                                <p className="text-gray-600">sales@smartdairy.co.in</p>
                                <p className="text-sm text-gray-500">We'll respond within 24 hours</p>
                            </div>
                        </div>

                        <div className="flex items-start space-x-4">
                            <div className="bg-[#002047] p-3 rounded-lg">
                                <MapPin className="h-6 w-6 text-white" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-[#002047] mb-2">Address</h3>
                                <p className="text-gray-600">1st Floor Above Upkar Store, Plot No. 47,<br />Saheli Marg, Panchwati, Udaipur, Rajasthan 313001</p>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white p-8 rounded-xl shadow-lg">
                        <form className="space-y-6">
                            <div className="grid md:grid-cols-2 gap-4">
                                <div>
                                    <label className="block text-sm font-medium text-[#002047] mb-2">First Name</label>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#002047] focus:border-transparent"
                                        placeholder="John"
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-[#002047] mb-2">Last Name</label>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#002047] focus:border-transparent"
                                        placeholder="Smith"
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-[#002047] mb-2">Email</label>
                                <input
                                    type="email"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#002047] focus:border-transparent"
                                    placeholder="john@company.com"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-[#002047] mb-2">Company</label>
                                <input
                                    type="text"
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#002047] focus:border-transparent"
                                    placeholder="Your Dairy Company"
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-[#002047] mb-2">Message</label>
                                <textarea
                                    rows={4}
                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#002047] focus:border-transparent"
                                    placeholder="How can we help you?"
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                className="w-full bg-[#002047] text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-800 transition-colors"
                            >
                                Send Message
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Contact
